<template>
  <div class="order_confirm" v-if="checkout">
    <van-nav-bar
      title="确认订单"
      left-text=""
      right-text=""
      left-arrow
      @click-left="back"
    />

    <div class="card" style="padding-bottom: 20px;" v-if="checkout.need_address">
      <div style="height: 20px;"></div>
      <div class="sm" style="margin-bottom: 15px;">收货地址</div>
      <div class="app-cell" @click="onSelect">
        <div class="app-navigator navi" v-if="checkout.address">
          <div style="width: 350px;">
            <div class="app-dis-vcenter-row h">
              <div>{{ checkout.address.name }}</div>
              <div style="margin-left: 15px;">{{ checkout.address.tel }}</div>
            </div>
            <div class="md" style="max-width: 298px;">
              {{ checkout.address.province }}{{ checkout.address.city }}{{ checkout.address.county }}{{ checkout.address.detail }}
            </div>
          </div>
          <img
            src="https://nginx-front.oss-cn-shanghai.aliyuncs.com/running-sys/right-arrow.png"
            class="app-navigator-next"
          >
        </div>
        <div v-else class="confirm-order-add-address">
          <img src="http://nginx-front.oss-cn-shanghai.aliyuncs.com/running-sys/add_address.png" alt="" style="width:130px;"></div>
        </div>
    </div>

    <div class="card" style="margin-bottom: 0;">
      <div style="height: 10px;"></div>
      <div class="header">班级信息</div>
      <div class="body">
        <div class="title">
          <div>{{ checkout.clazz.clazz_name }}</div>
          <div v-if="!checkout.is_has_gift">¥ {{ checkout.clazz.contract_fee }}</div>
        </div>
        <div class="info">
          参与时间：{{ checkout.clazz.start_time_format2 }} ~ {{ checkout.clazz.end_time_format2 }}
          （{{ checkout.clazz.day_num }}天）
        </div>
        <div class="info">跑步天数：{{ checkout.clazz.run_days }}天｜每天距离：{{ checkout.clazz.day_distance }}公里</div>
      </div>
    </div>

    <div v-if="checkout.is_has_gift" class="card gift-card">
      <div style="height: 10px;"></div>
      <div class="Collocation">
        <div class="card-tit isShowTit"><span>请选择套餐</span></div>

        <van-radio-group v-model="selectedGiftId">
          <van-cell-group>
            <van-cell
              v-for="(gift, index) in checkout.gifts"
              :key="index"
              :class="{'active-gift': selectedGiftId === gift.uuid}"
              class="gift-block"
              title-class="cell-title"
              clickable
              @click="onGiftChoose(gift.uuid)"
            >
              <template slot="title">
                <div class="gift-title">{{gift.title}}</div>
              </template>
              <template slot="label">
                <div class="gift-content">{{gift.content}}</div>
                <div class="gift-price">¥{{gift.price_display }}</div>
              </template>
              <van-radio :name="gift.uuid" checked-color="#F54966"/>
            </van-cell>
          </van-cell-group>
        </van-radio-group>

      </div>
    </div>

    <div class="card">
      <div style="height: 10px;"></div>
      <div class="sm" style="margin-bottom: 10px; display: flex;">
        <div style="margin-right: 5px;">优惠信息</div>
        <!-- <van-icon name="question-o" @click="onPromHelp" /> -->
      </div>
      <div class="app-cell">
        <van-field
          v-model="promCode"
          label="365臻品ID"
          placeholder="请输入365臻品ID"
          right-icon="question-o"
          @click-right-icon="onPromHelp"
        >
          <!-- <van-button slot="button" size="small" type="danger" @click="onVerify">去验证</van-button> -->
        </van-field>
      </div>
    </div>

    <div class="card">
      <div style="height: 10px;"></div>
      <div class="header">付款信息</div>
      <div class="body">
        <div class="title">
          <div>商品总额</div>
          <div>¥ {{ orderPrice }}</div>
        </div>
      </div>
      <div class="body" style="margin-top:20px">
        <div class="title">
          <div>优惠金额</div>
          <div style="color: #ff7135;">¥ {{ discountPrice }}</div>
        </div>
      </div>
    </div>

    <bottom-pay-btn class="bgwhite" :price="realPrice" :fixed="true" @confirm="gotoPay" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { CellGroup, Cell, Toast, NavBar, Field, Icon, Button, CheckboxGroup, Checkbox, Panel, RadioGroup, Radio, Dialog } from 'vant'
import BottomPayBtn from '@/components/BottomPayBtn'
import { enrollClazz } from '@/api/clazz'
import { orderCreateCheckout, orderPay } from '@/api/order'
import { isWeixin, wrapToBr } from '@/utils/index'
import { callPay } from '@/utils/wx'

const PROM_PRICE = 1

export default {
  name: 'OrderConfirm',
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Panel.name]: Panel,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Dialog.name]: Dialog,
    BottomPayBtn
  },
  data () {
    return {
      selectedGiftId: null,
      needGifts: [],
      checkout: null,
      promCode: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkoutAddress'
    ]),
    selectedGift () {
      if (!(this.checkout && this.checkout.is_has_gift && this.selectedGiftId)) return null

      for (let index = 0; index < this.checkout.gifts.length; index++) {
        const gift = this.checkout.gifts[index]
        if (gift.uuid === this.selectedGiftId) {
          return gift
        }
      }
      return null
    },
    promPrice () {
      const re = /^10\d{9}$/
      if (!re.test(this.promCode)) {
        return 0
      }
      return PROM_PRICE
    },
    orderPrice () {
      let price = this.checkout.price
      const selectedGift = this.selectedGift
      if (this.checkout.is_has_gift && selectedGift) {
        price += parseFloat(selectedGift.price)
      }

      return price.toFixed(2)
    },
    discountPrice () {
      let price = parseFloat(this.orderPrice) - parseFloat(this.realPrice)
      price = price < 0 ? 0 : price
      return price.toFixed(2)
    },
    realPrice () {
      let price = this.checkout.price - this.promPrice
      const selectedGift = this.selectedGift
      if (this.checkout.is_has_gift && selectedGift) {
        price += parseFloat(selectedGift.price)
      }
      price = price < 0 ? 0 : price

      return price.toFixed(2)
    }
  },
  created () {
    let clazzId = this.$route.params.clazz_id || ''
    this.createCheckout(clazzId, {
      address_id: this.checkoutAddress
    })
  },
  methods: {
    async createCheckout (clazzId, data) {
      let response = await orderCreateCheckout(clazzId, data)
      this.checkout = response.data
      this.checkout.gifts.map((gift) => {
        gift.price_display = (parseFloat(gift.price) + this.checkout.clazz.contract_fee).toFixed(2)
        gift.content = wrapToBr(gift.content)
      })
      // if (this.checkout.gifts.length) {
      //   this.selectedGiftId = this.checkout.gifts[0].uuid
      // }
      this.$store.dispatch('setCheckoutAddress', this.checkout.address.uuid)
    },
    onSelect () {
      this.$router.push('/my/address?from=checkout&address_id=' + this.checkoutAddress + '&path=' + encodeURIComponent(this.$route.fullPath))
    },
    gotoPay () {
      if (this.checkout.gifts.length && !this.selectedGiftId) {
      //   Dialog.confirm({
      //     title: '确定支付',
      //     message: '该课程包含礼包，选择礼包更优惠哦！',
      //     confirmButtonText: '我再看看',
      //     cancelButtonText: '确认支付',
      //   }).then(() => {
      //     // on confirm
      //   }).catch(() => {
      //     this.onPay()
      //   });
      // } else {
      //   this.onPay()
        Toast('请选择套餐')
        return
      }
      this.onPay()
    },
    async onPay () {
      let response = null
      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      response = await enrollClazz(this.checkout.clazz.uuid, {
        address_id: this.checkoutAddress,
        gift_id: this.selectedGiftId,
        prom_code: this.promCode
      })
      Toast.clear()
      if (response.data.is_free) {
        this.$router.push('/')
        return
      }

      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      response = await orderPay(response.data.order_id)
      Toast.clear()

      if (isWeixin()) {
        callPay(response.data)
      } else {
        Toast('请使用微信浏览器')
      }
    },
    onGiftChoose(checked) {
      if (this.selectedGiftId && this.selectedGiftId === checked) {
        // this.selectedGiftId = null
      } else {
        this.selectedGiftId = checked
      }
    },
    onPromHelp () {
      Toast('输入小程序“365臻品”的个人ID，报名费更优惠，获取ID方法，详见公众号“365一起跑”报名文章注册指引')
    },
    onGiftShow () {
      Toast('支付完成后在订单详情处填写礼包具体信息')
    },
    onVerify () {
    },
    onToggle () {
      this.$refs.checkbox.toggle()
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">
.order_confirm {
  background-color: #f8f8f8;
  .sm {
    font-size: 30px;
    color: #c5c8cc;
    line-height: 1;
    font-weight: 700;
  }
  .h {
    font-size: 32px;
    color: #1d252c;
    line-height: 1;
    font-weight: 700;
    margin-bottom: 20px;
    line-height: 48px;
  }
  .md {
      font-size: 26px;
      color: #949494;
      line-height: 1;
  }
  .app-dis-vcenter-row {
    display: flex;
    align-items: center;
  }
  .app-navigator {
    display: flex;
    align-items: center;
  }
  .app-navigator-next{
      margin-left: 10px;
      width: 14px;
      height: 20px;
  }
  .card {
    background-color: #fff;
    padding: 0 25px 20px;
    margin-bottom: 20px;
    .header {
      font-size: 28px;
      color: #c5c8cc;
      font-weight: bold;
      margin-bottom: 40px;
    }
    .body {
      .title {
        display: flex;
        justify-content: space-between;
        font-size: 32px;
        color: #1D252C;
        line-height: 1;
        font-weight: bold;
        margin-bottom: 25px;
        // line-height: 0.48rem;
      }
      .info {
        font-size: 28px;
        color: #949494;
        line-height: 1.4;
        // margin-bottom: 15px;
      }
    }
  }
  .Collocation {
    overflow-y: hidden;
    // border: 2px solid #ebebeb;
    // padding: 30px;
    // box-sizing: border-box;
    border-radius: 14px;
    .cell-title {
      flex: 7;
    }
    .card-tit {
      font-size: 32px;
      font-weight: 700;
      color: #000;
      margin-bottom: 20px;
    }
    .gift-title {
      font-size: 30px;
      color: #1d252c;
    }
    .gift-content {
      font-size: 26px;
      color: #1d252c;
      margin-top: 10px;
    }
    .gift-price {
      font-size: 26px;
      font-weight: 700;
      color: #1d252c;
      margin-top: 10px;
    }
    .gift-block {
      border: 2px solid #f8f8f8;
      border-radius: 10px;
      background-color: #f8f8f8;
      margin-bottom: 20px;
    }
    .active-gift {
      border-color: #F54966;
    }
  }
}
</style>
